import { isAxiosError } from "axios";

export type ExplorerConnectionLimitErrorBody = {
  message?: string;
  code?: string;
  used?: number;
  limit?: number;
  remaining?: number;
  weekResetsUtc?: string;
};

export function isExplorerConnectionWeeklyLimitError(error: unknown): boolean {
  if (!isAxiosError(error)) return false;
  const status = error.response?.status;
  const data = error.response?.data as ExplorerConnectionLimitErrorBody | undefined;
  return status === 429 || data?.code === "explorer_connection_weekly_limit";
}

export function getExplorerLimitErrorWeekResetsUtc(error: unknown): string | undefined {
  if (!isAxiosError(error)) return undefined;
  const data = error.response?.data as ExplorerConnectionLimitErrorBody | undefined;
  return data?.weekResetsUtc;
}

export function getExplorerLimitErrorBody(
  error: unknown
): ExplorerConnectionLimitErrorBody | undefined {
  if (!isAxiosError(error)) return undefined;
  return error.response?.data as ExplorerConnectionLimitErrorBody | undefined;
}
